const saveToLocalStorage = (authorizedUserId, newFilters, filtersType) => {
  const data = JSON.parse(localStorage.getItem(authorizedUserId));
  const newData = {...data, [filtersType]: newFilters};
  localStorage.setItem(authorizedUserId, JSON.stringify(newData));
};

export default saveToLocalStorage;